"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Value = function Value(props) {
  var value = !props.value || props.value === '' ? '-' : props.value,
      title = !props.value || props.value === '' ? '' : props.value;
  return /*#__PURE__*/_react.default.createElement("label", {
    className: "input"
  }, props.label, /*#__PURE__*/_react.default.createElement("span", {
    className: "input__value",
    title: title
  }, value));
};

Value.defaultProps = {
  value: '-'
};
Value.propTypes = {
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.string
};
var _default = Value;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/value.js
// module id = 507
// module chunks = 0